import React from 'react';
import { CardData } from '../types/types';
import { CARD_ICONS } from '../utils/cardConstants';
import '../styles/Card.css';

// Import all HP icons
import glassesIcon from '../assets/hp_icons/glasses.png';
import hatIcon from '../assets/hp_icons/hat.png';
import scrollIcon from '../assets/hp_icons/scroll.png';
import owlIcon from '../assets/hp_icons/owl.png';
import letterIcon from '../assets/hp_icons/letter.png';
import timeturnerIcon from '../assets/hp_icons/timeturner.png';
import wandIcon from '../assets/hp_icons/wand.png';
import beerIcon from '../assets/hp_icons/beer.png';
import bookIcon from '../assets/hp_icons/book.png';
import goldenSnitchIcon from '../assets/hp_icons/golden-snitch.png';
import cauldronIcon from '../assets/hp_icons/cauldron.png';
import scarfIcon from '../assets/hp_icons/scarf.png';
import hogwartsCrestIcon from '../assets/hp_icons/hogwarts-crest.png';
import potionIcon from '../assets/hp_icons/potion.png';

// Map icon types to their image files
const iconImages: Record<string, string> = {
  'glasses': glassesIcon,
  'hat': hatIcon,
  'scroll': scrollIcon,
  'owl': owlIcon,
  'letter': letterIcon,
  'timeturner': timeturnerIcon,
  'wand': wandIcon,
  'beer': beerIcon,
  'book': bookIcon,
  'golden-snitch': goldenSnitchIcon,
  'cauldron': cauldronIcon,
  'scarf': scarfIcon,
  'hogwarts-crest': hogwartsCrestIcon,
  'potion': potionIcon
};

interface CardProps {
  data: CardData;
  onClick: (card: CardData) => void;
}

const Card: React.FC<CardProps> = ({ data, onClick }) => {
  const handleClick = () => {
    if (data.visible && !data.selected) {
      console.log('Clicking card:', data);
      onClick(data);
    } else {
      console.log('Card not clickable:', data.visible ? 'visible' : 'not visible', data.selected ? 'selected' : 'not selected');
    }
  };

  // Don't render card if it's been selected
  if (data.selected) {
    return null;
  }

  // Calculate z-index based on layer
  const zIndex = data.layer * 10;

  // Determine which icon to display based on card type
  const iconType = CARD_ICONS[data.type % CARD_ICONS.length];

  // Determine card visibility class
  const cardClass = data.visible ? 'card visible' : 'card hidden';

  return (
    <div
      id={data.id}
      className={cardClass}
      style={{
        left: `${data.position.x}px`,
        top: `${data.position.y}px`,
        zIndex: zIndex,
      }}
      onClick={handleClick}
    >
      <div className="card-inner">
        <div className={`card-icon ${iconType}`}>
          <img src={iconImages[iconType]} alt={iconType} className="card-icon-image" />
        </div>
      </div>
    </div>
  );
};

export default Card; 